import { IconProps } from "./types";

const ArrowSideIcon: React.FC<IconProps> = ({ className }) => {
  return <img className={className} src="../../assets/images/arrows.svg" alt="" />;
};

export default ArrowSideIcon;
